/*
 * @Description:
 * @Date: 2021-10-25 20:13:35
 */

// 审核
export const auditStatusMapping = {
  0: '未提交审核',
  1: '审核中',
  2: '审核通过',
  3: '审核未通过',
  4: '-',
  5: '审核中（重新提交）'
};
// 任务记录下载
export const recordExportUrl = {
  4: '/rest/cso/saas/export/exportPatientVisitDataNew', //患教会
  5: '/rest/cso/saas/exportTask', //调研问卷
  6: '/rest/cso/saas/exportTask', //数字专区
  11: '/rest/cso/saas/export/exportMarketAccessDataNew', //特级三甲医院市场准入
  12: '/rest/cso/saas/export/exportMarketAccessDataNew', //三级医院市场准入
  13: '/rest/cso/saas/export/exportMarketAccessDataNew', //二级医院市场准入
  14: '/rest/cso/saas/export/exportMarketAccessDataNew', //基层医疗机构市场准入
  15: '/rest/cso/saas/export/exportMarketAccessDataNew', //零售药店市场准入
  17: '/rest/cso/saas/exportTask', //数字拜访
  18: '/rest/cso/saas/exportTask', //病例征集
  19: '/rest/cso/saas/exportTask', //协定服务
  20: '/rest/cso/saas/exportTask', //可配置场景
  21: '/rest/cso/saas/exportTask' //数字问卷
};
